module.exports = __webpack_public_path__ + "static/img/ancmt-icon.431ecce.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ancmt-icon.png
// module id = AMeU
// module chunks = 2